// Changelog del portal. Es contenido, no interfaz: la pagina de releases solo
// lo recorre y lo pinta.
//
// Antes vivia como 200 lineas de JSX donde cada version repetia la misma
// estructura a mano, con <br /> entre medias para separar. Anadir una release
// significaba copiar marcado y acordarse de mover la etiqueta "Latest".
//
// Para publicar una version nueva se anade su entrada arriba del todo. La
// etiqueta "Latest" sale sola de la posicion, ya no se escribe a mano.
//
// Un grupo es un titular de actualizacion y dentro van sus entradas. Una entrada
// sin version es una fecha extra dentro de la anterior, que es como estaba la
// 4.23.2 con sus dos tandas de agosto.
const RELEASES = [
	{
		title: "Seat7 Portal October Update - 2026 Release",
		entries: [
			{
				version: "4.5.0",
				build: "101326",
				date: "Oct 13, 2026",
				changes: [
					"New Resources section: a personal image library with folders, reachable from the main menu",
					"Images stored in Resources can now be inserted into the project descriptions of About the game and About company",
					"Images can be uploaded straight from the description editor, without leaving the page to visit Resources",
					"Image uploads now accept every image format instead of only PNG and JPEG",
					"Fixed image uploads failing across the portal: project logos, project banners and profile pictures",
					"Creating a project no longer leaves an empty project behind when a step fails midway",
					"Fixes in the project edit page: file link editing, delete confirmations and required field warnings",
					"Long descriptions are no longer cut off while typing in the project creation form",
					"Text and images in project descriptions no longer overflow their container",
					"The user profile now shows the account details and the current profile picture",
					"Redesigned the Official Releases page",
				],
			},
		],
	},
	{
		title: "Seat7 Portal November Update - 2025 Release",
		entries: [
			{
				version: "4.4.2",
				build: "111325",
				date: "Nov 13, 2025",
				changes: [
					"Updating the upload methods from the Seat7 API (https://services.api.seat7entertainment.com/api)",
					"Performance improvements in the information loading process",
					"View of the latest project submission to companies",
					"Publisher configurations Selected items display information from the selected lists.",
					"Compatibility improvements in contact and contact list imports",
					"Important fixes within the API modifying endpoints",
					"Improvements to the publisher and company information search sections",
					"List mode has been enabled, helping you filter companies with their project content",
					"The content view has been updated from 100 to 500 items per list",
					"Text fixes have been made to email previews",
					"Search filters have been added to most pages containing publisher and contact lists",
					"The contact search tool is enabled in project submission and contact search modals",
				],
			},
		],
	},
	{
		title: "Seat7 Portal October Update - 2025 Release",
		entries: [
			{
				version: "4.4.1",
				build: "101325",
				date: "Oct 13, 2025",
				changes: [
					"Incorporation of security metrics in user logins and registrations",
					"Implementation of stricter Google ReCaptcha registrations",
				],
			},
			{
				version: "4.4.0",
				build: "100825",
				date: "Oct 08, 2025",
				changes: [
					"Compatibility improvements in contact and contact list imports",
					"Important fixes within the API modifying endpoints",
					"Improvements to the publisher and company information search sections",
					"List mode has been enabled, helping you filter companies with their project content",
					"The content view has been updated from 100 to 500 items per list",
					"Text fixes have been made to email previews",
					"Search filters have been added to most pages containing publisher and contact lists",
					"The contact search tool is enabled in project submission and contact search modals",
				],
			},
		],
	},
	{
		title: "Seat7 Portal October Update - 2024 Release",
		entries: [
			{
				version: "4.3.2",
				date: "Oct 23, 2024",
				changes: [
					"Compatibility improvements in contact and contact list imports",
					"Important fixes within the API modifying endpoints",
					"The contact search tool is enabled in project submission and contact search modals",
				],
			},
		],
	},
	{
		title: "Seat7 Portal September Update - 2023 Release",
		entries: [
			{
				version: "4.3.1",
				date: "Sep 25, 2023",
				changes: [
					"There is a new name in the seat7 portal, Now publishers become contacts and clients become providers",
					"The administration of contacts for providers (previously clients) is eliminated",
					"Bug Fixes",
					"The implementation of contact import is improved (Now it allows updating the record of each user and adding it if it does not exist in the current list)",
				],
			},
		],
	},
	{
		title: "Seat7 Portal May Update - 2023 Release",
		entries: [
			{
				version: "4.3.0",
				date: "May 15, 2023",
				changes: [
					"Update of New administrator resources",
					"Feature of importing a list of publishers from a CSV file",
					"Bug Fixes",
					"Support for active components in JSON format",
					"Scalable information redirection from our API.",
				],
			},
		],
	},
	{
		title: "Seat7 Portal July Update - 2023 Release",
		entries: [
			{
				version: "4.23.2",
				date: "August 03, 2023",
				changes: [
					"Important changes in the administration of the email delivery center",
					"Changes to the delivery method of email addresses on services.api.seat7entertainment.com",
				],
			},
			{
				version: null,
				date: "August 25, 2023",
				changes: [
					"Incorporation of alerts in the image upload sections of the projects",
				],
			},
			{
				version: "4.23.1",
				date: "July 19, 2023",
				changes: [
					"Image rendering improvements",
					"Direct Access to the Pink Genie Portal",
					"Bug Fixes",
					"Stability in Supported Browsers",
					"Modal notifications when updating files",
				],
			},
		],
	},
	{
		title: "Seat7 Portal January Update - 2023 Release",
		entries: [
			{
				version: "4.23.0",
				date: "January 06, 2023",
				changes: [
					"Bug Fixes",
					"Stability in Supported Browsers",
					"Modal notifications when updating files",
					"Details Button on Publisher Modal",
					"Search Bar",
				],
			},
		],
	},
	{
		title: "Seat7 Portal November Update - 2022 Release",
		entries: [
			{
				version: "4.22.1",
				date: "November 23, 2022",
				changes: [
					"Api Security Patch - Delivery Method",
					"Bug Fixes on Delivery Methods",
				],
			},
			{
				version: "4.22.0",
				date: "November 01, 2022",
				changes: [
					"Api Security Patch",
					"Bug Fixes",
					"Stability in Supported Browsers",
					"Iconography",
				],
			},
		],
	},
	{
		title: "Seat7 Portal September Update - 2022 Release",
		entries: [
			{
				version: "4.21.0",
				date: "September 19, 2022",
				changes: [
					"Responsive Design",
					"Bug Fixes",
					"Stability in Supported Browsers",
					"Fixed mute error handling for NodeJS",
					"Fixed email templates",
				],
			},
		],
	},
];

export default RELEASES;
